function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-delete"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "delete",
  clipPath: "url(#clip-delete)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(0.32 0.32)"
}, /*#__PURE__*/React.createElement("g", {
  id: "trash-2",
  transform: "translate(-0.32 -0.32)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 20,
  height: 20,
  fill: "#e84a50",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M17.271,5.215H13.252V3.872A1.945,1.945,0,0,0,11.243,2H8.832A1.945,1.945,0,0,0,6.822,3.872V5.215H2.8a.8.8,0,1,0,0,1.607h.8v8.841a2.411,2.411,0,0,0,2.411,2.411h8.037a2.411,2.411,0,0,0,2.411-2.411V6.822h.8a.8.8,0,0,0,0-1.607ZM8.43,3.872c0-.129.169-.265.4-.265h2.411c.233,0,.4.137.4.265V5.215H8.43Zm6.43,11.791a.8.8,0,0,1-.8.8H6.019a.8.8,0,0,1-.8-.8V6.822H14.86Z",
  transform: "translate(-0.037 -0.037)",
  fill: "#e84a50"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M8.8,15.822a.8.8,0,0,0,.8-.8V11.8A.8.8,0,0,0,8,11.8v3.215A.8.8,0,0,0,8.8,15.822Z",
  transform: "translate(-1.215 -1.804)",
  fill: "#e84a50"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M14.8,15.822a.8.8,0,0,0,.8-.8V11.8A.8.8,0,0,0,14,11.8v3.215A.8.8,0,0,0,14.8,15.822Z",
  transform: "translate(-2.393 -1.804)",
  fill: "#e84a50"
}))));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.fd476481.svg";
export { ForwardRef as ReactComponent };